export const CSS_ITEM_SALE_GO_BUTTON_ACTION = ' CSS_ITEM_SALE_GO_BUTTON_ACTION '
export const CSS_ITEM_SALE_GO_BUTTON_SUCCESS = ' CSS_ITEM_SALE_GO_BUTTON_SUCCESS'

export const CSS_ITEM_SALE_REPORT_API_ERROR_ACTION = 'CSS_ITEM_SALE_REPORT_API_ERROR_ACTION'